import PropTypes from 'prop-types'
import Container from '@material-ui/core/Container'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import defaults from '@config/defaults'
import { useRouter } from 'next/router'
import { NextSeo } from 'next-seo'
import EventCtaBox from '@components/event-cta-box/event-cta-box'
import LandingPageHeader from '@components/landing-page-header/index'
import ErrorBoundary from '@components/error/boundary'
import Hero from '@components/hero-events'
import StorySpotlightWithData from '@components/story-spotlight/story-spotlight.query'
import ProgramGrid from '@components/program-grid/index'
import useStyles from './member-events-landing.styles'

const MemberEventsLanding = (props) => {
  const {
    headline,
    heroImage,
    featuredEvent,
    eventCategoriesCollection,
    ctaBoxesCollection,
    metaTitle,
    metaDescription,
    metaImage,
    eventGridHeadline,
    parentCollection,
    featuredStoriesQuery,
  } = props

  const multiple = ctaBoxesCollection.items.length > 1
  const styles = useStyles({ multiple })
  const router = useRouter()

  if (!router) return null

  return (
    <div className={styles.root}>
      <NextSeo
        noindex={defaults.noindexNofollow}
        nofollow={defaults.noindexNofollow}
        title={metaTitle}
        description={metaDescription}
        canonical={`${defaults.baseUrl}member-events`}
        openGraph={{
          title: metaTitle,
          type: 'website',
          url: `${defaults.baseUrl}${router.asPath.substring(1)}`, // trimming string because of /
          images: [{ url: (metaImage && metaImage.url) }],
        }}
      />
      <LandingPageHeader headline={headline} />
      <ErrorBoundary>
        <Hero
          headline={headline}
          heroImage={heroImage}
          featuredEvent={featuredEvent}
        />
      </ErrorBoundary>
      <ErrorBoundary>
        <ProgramGrid headline={eventGridHeadline} {...eventCategoriesCollection} />
      </ErrorBoundary>
      {ctaBoxesCollection && !!ctaBoxesCollection.items.length && (
        <Container className={styles.ctaBoxWrapper}>
          <Grid container display="flex" className={styles.ctaBoxContainer}>
            {ctaBoxesCollection.items.map(item => (
              <EventCtaBox key={item.sys.id} {...item} className={styles.ctaBox} />
            ))}
          </Grid>
        </Container>
      )}
      <ErrorBoundary>
        <Box bgcolor="white" pt={0}>
          <StorySpotlightWithData
            graphqlQuery={featuredStoriesQuery}
            parentCollection={parentCollection}
          />
        </Box>
      </ErrorBoundary>
    </div>
  )
}

MemberEventsLanding.propTypes = {
  query: PropTypes.object,
  headline: PropTypes.string,
  heroImage: PropTypes.shape({
    url: PropTypes.string,
  }),
  featuredEvent: PropTypes.shape({
    headline: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    slug: PropTypes.string,
    image: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
  eventCategoriesCollection: PropTypes.shape({
    total: PropTypes.number,
    items: PropTypes.array,
  }),
  ctaBoxesCollection: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.object),
  }),
  metaTitle: PropTypes.string,
  metaDescription: PropTypes.string,
  metaImage: PropTypes.shape({
    url: PropTypes.string,
  }),
  eventGridHeadline: PropTypes.string,
  parentCollection: PropTypes.string,
  featuredStoriesQuery: PropTypes.object,
}

export default MemberEventsLanding
